var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 16C4.97292 15.5333 3.29933 14.4699 1.97925 12.8096C0.659167 11.1493 -0.000582947 9.30613 3.86484e-07 7.28V2.4L7 0L14 2.4V7.28C14 9.30667 13.3403 11.1501 12.0208 12.8104C10.7013 14.4707 9.02767 15.5339 7 16ZM5.25 11.2H8.75C8.99792 11.2 9.20588 11.1232 9.37388 10.9696C9.54187 10.816 9.62558 10.6261 9.625 10.4V8C9.625 7.77333 9.541 7.58347 9.373 7.4304C9.205 7.27733 8.99733 7.20053 8.75 7.2V6.4C8.75 5.96 8.57879 5.58347 8.23637 5.2704C7.89396 4.95733 7.48183 4.80053 7 4.8C6.51875 4.8 6.10692 4.9568 5.7645 5.2704C5.42208 5.584 5.25058 5.96053 5.25 6.4V7.2C5.00208 7.2 4.79442 7.2768 4.627 7.4304C4.45958 7.584 4.37558 7.77387 4.375 8V10.4C4.375 10.6267 4.459 10.8168 4.627 10.9704C4.795 11.124 5.00267 11.2005 5.25 11.2ZM6.125 7.2V6.4C6.125 6.17333 6.209 5.98347 6.377 5.8304C6.545 5.67733 6.75267 5.60053 7 5.6C7.24792 5.6 7.45588 5.6768 7.62388 5.8304C7.79188 5.984 7.87558 6.17387 7.875 6.4V7.2H6.125Z",
    fill: "#5AAD46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.065deede1f71d6c0e580d5738c9058f1.svg";
export { ForwardRef as ReactComponent };